"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _propTypes = require("prop-types");

var _core = require("@material-ui/core");

var _InfoOutlined = _interopRequireDefault(require("@material-ui/icons/InfoOutlined"));

var _ = require("../../..");

var css = _interopRequireWildcard(require("./PaymentSummary.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PaymentSummary = function PaymentSummary(_ref) {
  var feeDate = _ref.feeDate,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      monthlyFee = _ref.monthlyFee,
      onFeeClick = _ref.onFeeClick,
      zeroBalanceDate = _ref.zeroBalanceDate;
  return (0, _jsxRuntime.jsx)(_.Paper, {
    css: css.paymentSummary,
    children: (0, _jsxRuntime.jsxs)("div", {
      children: [feeDate && (0, _jsxRuntime.jsxs)("div", {
        css: css.paymentSummaryRow(isLoading),
        children: [(0, _jsxRuntime.jsxs)("span", {
          children: ["Account fee on ", feeDate, (0, _jsxRuntime.jsx)("button", {
            css: css.iconButton,
            onClick: onFeeClick,
            type: "button",
            "aria-label": "info",
            children: (0, _jsxRuntime.jsx)(_core.SvgIcon, {
              css: css.icon,
              component: _InfoOutlined["default"],
              titleAccess: "info"
            })
          })]
        }), (0, _jsxRuntime.jsxs)("span", {
          children: ["$", monthlyFee]
        })]
      }), (0, _jsxRuntime.jsxs)("div", {
        css: css.paymentSummaryRow(isLoading),
        children: [(0, _jsxRuntime.jsx)("span", {
          children: "Total owing paid off"
        }), (0, _jsxRuntime.jsx)("span", {
          children: zeroBalanceDate
        })]
      })]
    })
  });
};

PaymentSummary.propTypes = {
  feeDate: _propTypes.string,
  isLoading: _propTypes.bool,
  monthlyFee: _propTypes.number.isRequired,
  onFeeClick: _propTypes.func.isRequired,
  zeroBalanceDate: _propTypes.string.isRequired
};
PaymentSummary.defaultProps = {
  isLoading: false,
  feeDate: undefined
};
var _default = PaymentSummary;
exports["default"] = _default;